import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Injector,
  Type,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

interface DialogContainerData {
  title: string;
  component?: Type<any>;
  injector?: Injector;
}

@Component({
  selector: 'app-dialog-container',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDividerModule],
  template: `
    <div class="relative">
      <div class="flex flex-row justify-between items-center pb-2">
        <div class="text-xl font-bold">{{ data.title }}</div>
        <button
          mat-icon-button
          (click)="closeDialog()"
          [autofocus]="false"
          tabIndex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      @if (data.component) {
        <ng-container
          *ngComponentOutlet="data.component; injector: data.injector" />
      }
    </div>
    `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogContainerComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContainerData
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
